import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import React from 'react';

const structuredData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "RealTech LLC",
    "url": "https://www.homecarechecks.com",
    "logo": "https://www.homecarechecks.com/assets/logos/logo.png",
    "contactPoint": [{
        "@type": "ContactPoint",
        "telephone": "+1-615-708-0787",
        "contactType": "Customer Support",
        "areaServed": "US"
    }]
};

export default function BackgroundChecks() {
    return (
        <main>
            <Header
                title="Background Checks Built for Homecare Agencies | FortiTeam"
                description="Designed by a homecare agency, Real Checks delivers fast, transparent, and compliant background screening tailored for caregiver vetting and ongoing monitoring."
                structuredData={structuredData}
            />
            <HeroSection
                heading="Home Care Focused Background Check System"
                subheading="Built by a Homecare Agency"
                tagline="To Vet and Check Caregivers"
            />

            <section className="trusted-logos">
                <h2>Trusted by These National Franchises</h2>
                <div className="logo-strip">
                    <img src="/assets/logos/sr-helpers.png" alt="Senior Helpers" />
                    <img src="/assets/logos/right-at-home.png" alt="Right at Home" />
                    <img src="/assets/logos/comforcare.png" alt="ComForCare" />
                </div>
            </section>

           <section className="video-highlight">
			  <div className="video-container">
				<iframe
				  src="https://www.youtube.com/embed/QP89TggPicQ"
				  title="Real Checks Demo"
				  frameBorder="0"
				  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
				  allowFullScreen
				></iframe>
			  </div>
			  <div className="video-text">
				<h2>Less Time in SYSTEMS and More on SUPPORT</h2>
				<p>
				  We understand the daily challenge of running a busy office balancing staff, clients, and compliance while dealing with a time-consuming background check process. That’s why we built a simpler, smarter way.
				</p>
			  </div>
			</section>
        </main>
    );
}
